var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isPreview)?_c('header',[_c('header-desktop',{staticClass:"d-lg-block d-none"}),_c('header-mobile',{staticClass:"d-lg-none d-block"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }